import { useParams } from "react-router-dom";
import { useApiQuery } from "../../../../../../common/infrastructure/hooks/useApiQuery";
import { endpointsMetadata } from "../../../../../../common/infrastructure/routes/endpointsMetadata";
import { IUseWorkoutStatisticsArgs } from "../../../../../portal/myWorkouts/statistics/hooks/useWorkoutStatistics";
import { IUseWorkoutAchievementsArgs } from "../../../../../portal/myWorkouts/achievements/hooks/useWorkoutAchievements";
import { IUserModel } from "../../models/userModel";

/**
 * Backs the admin user-profile workouts page. Resolves the target user (for the
 * dialog subtext) and builds the userId-scoped list/statistics data sources the
 * shared WorkoutsOverview renders — the same view the user sees on My Workouts.
 */
export const useUserWorkoutsPage = () => {
  const { id } = useParams();
  const userId = Number(id);

  const { data: user, isLoading } = useApiQuery<IUserModel>({
    queryKey: [endpointsMetadata.user.getUser, id],
    endpoint: `${endpointsMetadata.user.getUser}?userId=${id}`,
    enabled: id !== undefined,
    globalIsLoading: false,
  });

  const userName = user
    ? `${user.firstName} ${user.lastName}`.trim()
    : undefined;

  const listEndpoint = `${endpointsMetadata.workoutPlan.getUserWorkoutsDetailed}?userId=${userId}`;
  const listQueryKey = [
    endpointsMetadata.workoutPlan.getUserWorkoutsDetailed,
    userId,
  ];

  const statistics: IUseWorkoutStatisticsArgs = {
    endpoint: endpointsMetadata.workoutPlan.getUserWorkoutStatistics,
    queryKeyBase: endpointsMetadata.workoutPlan.getUserWorkoutStatistics,
    extraParams: { userId },
  };

  const achievements: IUseWorkoutAchievementsArgs = {
    endpoint: endpointsMetadata.workoutPlan.getUserWorkoutAchievements,
    queryKeyBase: endpointsMetadata.workoutPlan.getUserWorkoutAchievements,
    extraParams: { userId },
  };

  return {
    userId,
    userName,
    isLoading,
    listEndpoint,
    listQueryKey,
    statistics,
    achievements,
  };
};
